import { Flex } from 'components/layout';

import DrumkitLogo from '../../../../../../assets/drumkit-logo.png';

// Kit's avatar, as in the Kit suggestions header, sized for a card header.
export function KitAvatar() {
  return (
    <Flex
      align='center'
      justify='center'
      className='h-5 w-5 shrink-0 rounded-full border border-brand bg-brand-100'
      title='Kit, your Drumkit AI agent'
    >
      <img
        src={DrumkitLogo}
        alt=''
        className='h-2.5 w-2.5 object-contain'
        aria-hidden
      />
    </Flex>
  );
}
